export enum EventType {
	Binary = 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
	Probability = 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
}
